import React from 'react';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { required } from '../../../util/validators';
import {
  Button,
  FieldTextInput,
  Form,
  Modal,
  PrimaryButton,
} from '../../../components';

import css from './OwnShippingTrackingModal.module.css';

const OwnShippingTrackingForm = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        className,
        rootClassName,
        disabled,
        formId,
        handleSubmit,
        invalid,
        onCancel,
        trackingError,
        trackingInProgress,
        trackingSubmitted,
      } = fieldRenderProps;
      const intl = useIntl();
      const classes = classNames(rootClassName || css.formRoot, className);
      const submitInProgress = trackingInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
      const errorMessageMaybe = trackingError ? (
        <FormattedMessage id="OwnShippingTrackingForm.submitFailed" />
      ) : null;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          <FieldTextInput
            className={css.inputField}
            type="text"
            id={formId ? `${formId}.carrier` : 'carrier'}
            name="carrier"
            label={intl.formatMessage({ id: 'OwnShippingTrackingForm.carrierLabel' })}
            placeholder={intl.formatMessage({ id: 'OwnShippingTrackingForm.carrierPlaceholder' })}
            validate={required(
              intl.formatMessage({ id: 'OwnShippingTrackingForm.carrierRequired' })
            )}
          />
          <FieldTextInput
            className={css.inputField}
            type="text"
            id={formId ? `${formId}.trackingNumber` : 'trackingNumber'}
            name="trackingNumber"
            label={intl.formatMessage({ id: 'OwnShippingTrackingForm.trackingNumberLabel' })}
            placeholder={intl.formatMessage({
              id: 'OwnShippingTrackingForm.trackingNumberPlaceholder',
            })}
            validate={required(
              intl.formatMessage({ id: 'OwnShippingTrackingForm.trackingNumberRequired' })
            )}
          />
          <p className={css.errorPlaceholder}>{errorMessageMaybe}</p>
          <div className={css.actions}>
            <Button
              className={css.cancelButton}
              type="button"
              disabled={submitInProgress}
              onClick={onCancel}
            >
              {intl.formatMessage({ id: 'OwnShippingTrackingForm.cancel' })}
            </Button>
            <PrimaryButton
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={trackingSubmitted}
            >
              {intl.formatMessage({ id: 'OwnShippingTrackingForm.submit' })}
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

const OwnShippingTrackingModal = props => {
  const intl = useIntl();
  const {
    className,
    rootClassName,
    id,
    isOpen = false,
    focusElementId,
    onCloseModal,
    onManageDisableScrolling,
    onSubmitTracking,
    trackingSubmitted = false,
    trackingInProgress = false,
    trackingError,
  } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <Modal
      id={id}
      containerClassName={classes}
      contentClassName={css.modalContent}
      isOpen={isOpen}
      onClose={onCloseModal}
      onManageDisableScrolling={onManageDisableScrolling}
      focusElementId={focusElementId}
      usePortal
      closeButtonMessage={intl.formatMessage({ id: 'OwnShippingTrackingModal.close' })}
    >
      <p className={css.modalTitle}>
        <FormattedMessage id="OwnShippingTrackingModal.title" />
      </p>
      <p className={css.modalMessage}>
        <FormattedMessage id="OwnShippingTrackingModal.description" />
      </p>
      <OwnShippingTrackingForm
        onSubmit={onSubmitTracking}
        onCancel={onCloseModal}
        trackingSubmitted={trackingSubmitted}
        trackingInProgress={trackingInProgress}
        trackingError={trackingError}
      />
    </Modal>
  );
};

export default OwnShippingTrackingModal;
